import React from 'react';

import { LinkElement } from '@els/els-react--link-element';
import { Icon } from '@els/els-react--icon';
import { useBuildInfo } from './useBuildInfo';
import { useFormatBuildInfo } from './useFormatBuildInfo';

import './InfoBar.scss';

function InfoBar() {
  const buildInfo = useBuildInfo();
  const data = useFormatBuildInfo(buildInfo);
  const items = [
    { value: data.substances || 0, icon: 'icon-substances', label: 'Substances' },
    { value: data.reactions || 0, icon: 'icon-reactions', label: 'Reactions' },
    { value: data.citations || 0, icon: 'icon-citations', label: 'Documents' },
    { value: data.patents || 0, icon: 'icon-patents', label: 'Patents' },
    { value: data.dpitems || 0, icon: 'icon-tgitems', label: 'Bioactivities' },
  ];

  return (
    <div className="info-bar--container">
      <div className="u-els-margin-bottom-1x u-els-line-height-heading">
        <span>Content Overview</span>
        {!!data.lastUpdated && (
          <span className="pipe-left">
            <LinkElement
              id="latest-update-content"
              className="u-els-color-text"
              href="/#/about-content"
              a11y={{ name: 'About content' }}
              isExternal
              noExternalIcon>
              Latest update: {data.lastUpdated}
              <Icon className="u-els-color-link-inline u-els-margin-left-1o4" sprite="ChevronRight" size="xs" isDecorative />
            </LinkElement>
          </span>
        )}
      </div>

      <ul className="u-els-display-flex" aria-label="Content statistics">
        {items.map((item) => (
          <li key={item.label} className="u-els-margin-right-1x1o2 u-els-text-center">
            <span
              className="u-els-display-block u-els-font-size-h2 u-els-padding-bottom-1o4 u-els-color-n9"
              aria-label={`${item.value} million ${item.label?.toLowerCase()}`}>
              {item.value}M
            </span>
            <span className="u-els-font-size-body-large">
              <svg className="rx-btn-icon u-els-color-secondary" aria-hidden="true">
                <use href={`#${item.icon}`} />
              </svg>
              <span className="u-els-display-inline-block u-els-color-n9">{item.label}</span>
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default InfoBar;
